import { useState, useEffect } from "react";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import Icon from "@mui/material/Icon";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";

// Désignation du couple marié dans une inscription de type famille.
// props:
//  - inscription: { id, type_inscription, participants: [{id, prenom, nom, conjoint_id}] }
//  - onSave: (participant1_id, participant2_id) => Promise  (null,null pour délier)
function DesignationCouple({ inscription, onSave }) {
  const participants = inscription?.participants || [];
  // Couple existant (la 1ère paire liée)
  const lie = participants.find((p) => p.conjoint_id);
  const [p1, setP1] = useState(lie ? lie.id : "");
  const [p2, setP2] = useState(lie ? lie.conjoint_id : "");
  const [saving, setSaving] = useState(false);
  const [msg, setMsg] = useState("");

  useEffect(() => {
    const l = (inscription?.participants || []).find((p) => p.conjoint_id);
    setP1(l ? l.id : "");
    setP2(l ? l.conjoint_id : "");
  }, [inscription]);

  if (!inscription) return null;
  const nomDeP = (p) => (p.prenom || "") + " " + (p.nom ? p.nom.toUpperCase() : "");

  // Pour un couple : mention en lecture seule
  if (inscription.type_inscription === "couple") {
    const lies = participants.filter((p) => p.conjoint_id);
    if (lies.length < 2) return null;
    return (
      <MDBox sx={{ bgcolor: "#f5f3ff", border: "1px solid #ddd6fe", borderRadius: "8px", p: 1.5, mt: 1.5 }}>
        <MDTypography variant="caption" fontWeight="bold" color="text">
          Couple marié : {nomDeP(lies[0])} et {nomDeP(lies[1])}
        </MDTypography>
      </MDBox>
    );
  }

  // Pour une famille : sélecteurs
  if (inscription.type_inscription !== "famille") return null;

  const enregistrer = async (a, b) => {
    setSaving(true);
    setMsg("");
    try {
      await onSave(a || null, b || null);
      setMsg(a && b ? "Couple enregistré." : "Couple retiré.");
      setTimeout(() => setMsg(""), 2500);
    } catch (err) {
      setMsg("Erreur");
    } finally {
      setSaving(false);
    }
  };

  const nomDe = (p) => (p.prenom || "") + " " + (p.nom ? p.nom.toUpperCase() : "");

  return (
    <MDBox sx={{ bgcolor: "#f5f3ff", border: "1px solid #ddd6fe", borderRadius: "8px", p: 1.5, mt: 1.5 }}>
      <MDTypography variant="caption" fontWeight="bold" color="text" display="block" mb={1}>
        
        &nbsp;Couple marié (pour chambre double mixte)
      </MDTypography>
      <MDBox display="flex" gap={1} alignItems="center" flexWrap="wrap">
        <FormControl size="small" sx={{ minWidth: 130 }}>
          <InputLabel id="couple-p1">Personne 1</InputLabel>
          <Select labelId="couple-p1" label="Personne 1" sx={{ height: 40 }}
            value={p1} onChange={(e) => setP1(e.target.value)}>
            <MenuItem value="">—</MenuItem>
            {participants.map((p) => (
              <MenuItem key={p.id} value={p.id} disabled={p.id === p2}>{nomDe(p)}</MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl size="small" sx={{ minWidth: 130 }}>
          <InputLabel id="couple-p2">Personne 2</InputLabel>
          <Select labelId="couple-p2" label="Personne 2" sx={{ height: 40 }}
            value={p2} onChange={(e) => setP2(e.target.value)}>
            <MenuItem value="">—</MenuItem>
            {participants.map((p) => (
              <MenuItem key={p.id} value={p.id} disabled={p.id === p1}>{nomDe(p)}</MenuItem>
            ))}
          </Select>
        </FormControl>
        <MDButton size="small" color="info" disabled={saving || !p1 || !p2}
          onClick={() => enregistrer(p1, p2)}>
          Lier
        </MDButton>
        {lie && (
          <MDButton size="small" color="secondary" variant="outlined" disabled={saving}
            onClick={() => { setP1(""); setP2(""); enregistrer(null, null); }}>
            Délier
          </MDButton>
        )}
        {msg && <MDTypography variant="caption" color="success">{msg}</MDTypography>}
      </MDBox>
    </MDBox>
  );
}

export default DesignationCouple;
